import { html } from 'lit';
import { Globe } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-globe')
export class PdsIconGlobe extends PdsIcon {
  @state()
  icon = Globe;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
